import React from "react";

import BaseSvg, { BaseSvgProps } from "../../BaseSvg";

const PoisonSvg: React.FunctionComponent<BaseSvgProps> = ({
  className = "",
  fillColor,
  secondaryFillColor,
}) => {
  return (
    <BaseSvg className={className} viewBox="0 0 12.93 18.44">
      <path
        fill={fillColor}
        d="M6.52,13.23q.83-.46,2.93-1.35l.54-.23a13.18,13.18,0,0,1,1.23-1.14,1.48,1.48,0,0,1,.71-.38.47.47,0,0,1,.4.17.84.84,0,0,1,.13.51,5.46,5.46,0,0,1-.09.83,2.06,2.06,0,0,1,.55,1,.57.57,0,0,1-.15.43.64.64,0,0,1-.46.15,1.19,1.19,0,0,1-.47-.16q-.31-.16-.8-.47a14.26,14.26,0,0,0-3.39,1.32l.41.24q.77.44,1.9,1.17l.64.39q2.34.27,2.34,1.18,0,.59-1.26.8-.59.72-1,.72t-.9-1.21-.14-.37a19.87,19.87,0,0,0-3.24-2.23A17.6,17.6,0,0,0,3.16,17Q3,18.44,2.29,18.44q-.42,0-1-.82Q0,17.62,0,16.9a.8.8,0,0,1,.49-.76,8.5,8.5,0,0,1,2.05-.47,23.22,23.22,0,0,1,2.78-1.72A14,14,0,0,0,1.8,12.63a3.1,3.1,0,0,1-.59.42,1.09,1.09,0,0,1-.5.14A.79.79,0,0,1,.2,13,.5.5,0,0,1,0,12.64a2.45,2.45,0,0,1,.57-1,3.69,3.69,0,0,1-.13-.8.88.88,0,0,1,.15-.57.55.55,0,0,1,.45-.19,1.39,1.39,0,0,1,.77.39A9.37,9.37,0,0,1,3,11.65,31,31,0,0,1,6.52,13.23Z"
      />
      <path
        fill={fillColor}
        d="M8.9,9.31l-.32,1.27-.78.68a1.42,1.42,0,0,1-.54.6,1.55,1.55,0,0,1-.8.2,1.42,1.42,0,0,1-1.34-.8l-.79-.68L4,9.31l.47-.12.12.3a1.93,1.93,0,0,0,.65.9,2.34,2.34,0,0,0,1.17.22,2.76,2.76,0,0,0,1.28-.21,1.85,1.85,0,0,0,.65-.91l.12-.3Z"
      />
      <path
        fill={fillColor}
        d="M9.67,1.07A4.82,4.82,0,0,0,6.42,0,4.82,4.82,0,0,0,3.17,1.07,3.49,3.49,0,0,0,1.93,3.85,4.36,4.36,0,0,0,2.33,6,4.4,4.4,0,0,1,2.88,7.2L3,8.28l1.81.86.26.65a3.45,3.45,0,0,0,.58.12,5.55,5.55,0,0,0,.74,0A4.19,4.19,0,0,0,7.75,9.8L8,9.14l1.8-.86L10,7.2a1.72,1.72,0,0,1,.13-.46,5.68,5.68,0,0,0,.82-2.89A3.49,3.49,0,0,0,9.67,1.07ZM4.55,7.18q-1.07,0-1.07-1.23a1.25,1.25,0,0,1,.28-.89,1.09,1.09,0,0,1,.83-.3q1,0,1,1.09Q5.64,7.18,4.55,7.18ZM6.79,8.91a.6.6,0,0,1-.31-.1.6.6,0,0,1-.31.1.53.53,0,0,1-.35-.1A.38.38,0,0,1,5.7,8.5,1,1,0,0,1,6,8a5.58,5.58,0,0,0,.48-.68A5,5,0,0,0,7,8a1,1,0,0,1,.31.53Q7.27,8.91,6.79,8.91ZM8.36,7.18q-1.08,0-1.08-1.23t1.1-1.18A1.06,1.06,0,0,1,9.18,5a1.14,1.14,0,0,1,.26.82Q9.44,7.18,8.36,7.18Z"
      />
    </BaseSvg>
  );
};

export default PoisonSvg;
